// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__6AYh3","content":"styles_content__NTZLI","selectAll":"styles_selectAll__2yTsm"};